import { render, staticRenderFns } from "./allConfig.vue?vue&type=template&id=7ed1c602&scoped=true&"
import script from "./allConfig.vue?vue&type=script&lang=js&"
export * from "./allConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed1c602",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed1c602')) {
      api.createRecord('7ed1c602', component.options)
    } else {
      api.reload('7ed1c602', component.options)
    }
    module.hot.accept("./allConfig.vue?vue&type=template&id=7ed1c602&scoped=true&", function () {
      api.rerender('7ed1c602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insureConfig/allConfig.vue"
export default component.exports